import { BrowserCacheLocation, IPublicClientApplication, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { ConfigService } from './config.service';
import { environment } from '@env/environment';
import {  Router } from '@angular/router';

export function MSALInstanceFactory(configService: ConfigService, router: Router): IPublicClientApplication {
    const instance = window.location.host.split('.')[0];
    const instanceRslt = configService.getConfig();
    console.log(instanceRslt);
    
    localStorage.setItem('instanceId',instanceRslt['DATA']['INSTANCEID'] );
     localStorage.setItem('instance',instance);
    localStorage.setItem('companyId', instanceRslt['DATA'].COMPANYID);
    localStorage.setItem('msalconfig', instanceRslt['DATA'].CONFIG);
    localStorage.setItem('adid', instanceRslt['DATA'].ADID);
    let tenantId;
    let clientId;
    // localStorage.setItem('msalconfig', instanceRslt['DATA'].CONFIG)
    if(instanceRslt['DATA']['CONFIG']){
        const msalConfig = JSON.parse(instanceRslt['DATA']['CONFIG']);
        tenantId = msalConfig['tenantID'];
        clientId = msalConfig['clientID'];
        console.log("tenantId"+tenantId);
        console.log("clientId"+clientId);
    }  
    else
        router.navigate(['/auth'])
    // console.log("config :: ",msalConfig);
   
    const domain = environment.domain;
    console.log("domain ",domain);

    return new PublicClientApplication({
        auth: {
        clientId: clientId,
        authority: `https://login.microsoftonline.com/${tenantId}`,
        redirectUri: `https://${instance}${domain}/autologin`,
        postLogoutRedirectUri: `https://${instance}${domain}/auth/logout`,
        },
        cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage,
        storeAuthStateInCookie: true, // set to true for IE 11. Remove this line to use Angular Universal
        },
        system: {
        allowRedirectInIframe: true,
        loggerOptions: {
            logLevel: LogLevel.Info,
            piiLoggingEnabled: false,
        },
        },
    });
}
